import { useCallback } from 'react'
import { useDeleteShipmentStopMutation } from '../../graphql/DeleteShipmentStopMutation'
import { useErrors } from '../useErrors'

/**
 * Handles mutation and errors for deleting a stop
 */
export const useDeleteStop = () => {
  const { errors, setErrors, errorMessages = [] } = useErrors()
  const [_deleteShipmentStop, { loading }] = useDeleteShipmentStopMutation()

  /**
   * Deletes a stop from the shipment
   * @example deleteShipmentStop('124522')
   */
  const deleteShipmentStop = useCallback(
    async (shipmentStopId: string) => {
      setErrors([])
      try {
        const response = await _deleteShipmentStop({
          variables: {
            input: {
              shipmentStopId,
            },
          },
          refetchQueries: ['ShipmentProgress'],
        })

        const { data } = response || {}
        const { deleteShipmentStop } = data || {}
        const { errors: apiErrors = [] } = deleteShipmentStop || {}
        setErrors(apiErrors)

        if (apiErrors.length) {
          return false
        }

        return true
      } catch (e) {
        return false
      }
    },
    [_deleteShipmentStop, setErrors]
  )

  return {
    deleteShipmentStop,
    errors,
    errorMessages,
    loading,
    setErrors,
  }
}
